import { ReactComponent as SuccessSvg } from 'src/assets/icons/succes-check.svg';
import { ReactComponent as SuccessYellowSvg } from 'src/assets/icons/success-check-yellow.svg';
import styled from 'styled-components';

export const SuccessIcon = styled(SuccessSvg)`
  height: 18px;
`;

export const SuccessYellowIcon = styled(SuccessYellowSvg)`
  width: 24px;
  height: 24px;
`;
